export const getUser = (state: any) => state.user;
export const getOtherUser = (state: any) => state.user.otherUser;
